import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { MenuItemsForDropDown } from "@soqs/common";
import CapacitySelector from "./CapacitySelector";
import SelectComponent from "./CustomComponents/SelectComponent";
import HalfColumn from "./CustomComponents/HalfColumn";
import {
  dropdownoptions,
  dropdownsloading,
  isKiosk,
} from "../features/AppSlice";

const UserIdentificationComponent = () => {
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);
  const kioskMode = useSelector(isKiosk);

  return (
    <Grid size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <Card>
          <CardContent>
            <CardHeader title="I'd like to see the Tax Return Status Dashboard for:" />
            <Grid container columnSpacing={1.5} rowSpacing={0.5}>
              <Grid size={{ xs: 12, md: 12 }}>
                <CapacitySelector disabled={kioskMode} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <br />
        <Card>
          <CardContent>
            <CardHeader title="For the Tax Year:" />
            <HalfColumn>
              <SelectComponent
                label="Tax Year"
                aria-label="Tax Year"
                name="TaxYear"
                required={true}
                options={MenuItemsForDropDown("taxyear", dropdownopts, false)}
                optionsloading={dropdownoptsloading}
              />
            </HalfColumn>
          </CardContent>
        </Card>
        <br />
      </Grid>
      <br />
    </Grid>
  );
};

export default UserIdentificationComponent;
